<!-- 帮助中心页面 -->
<template>
  <div class="help-center">
    <aside class="help-center-aside">
      <nav class="help-center-aside-nav">
        <svg-icon icon-class="light" />
        帮助中心
      </nav>
      <el-menu
        :default-active="dataid"
        class="el-menu-vertical-demo"
        background-color="#F5F5F5"
        text-color="#202020"
        active-text-color="#EC212D"
        :default-openeds="dataindex"
        @select="handleSelect"
        @open="handleOpen"
      >
        <el-menu-item-group>
          <el-submenu
            v-for="(item, index) in titleTwo"
            :key="index"
            :index="item.fdocTitle"
          >
            <template slot="title">
              {{ item.fdocTitle }}
            </template>
            <el-menu-item-group>
              <el-menu-item
                v-for="(items, indexs) in item.titleThree"
                :key="indexs"
                :index="items.fid + ''"
                @click.native="titleChnage(items.fid)"
              >{{ items.fdocName }}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu-item-group>
      </el-menu>
    </aside>
    <article class="help-center-article">
      <div class="article-html" v-html="html" />
      <div v-if="pjshow">
        <p class="article-title">这条帮助是否解决了您的问题?</p>
        <div class="article-button-box">
          <el-button
            :class="{ 'article-button': true, 'active-green': hasSolve }"
            @click="handleSolve(true)"
          >
            <svg-icon
              v-if="hasSolve === false || hasSolve === null"
              icon-class="solve"
            />
            <svg-icon v-if="hasSolve" icon-class="solve" />
            已解决
          </el-button>
          <el-button
            :class="{
              'article-button': true,
              'active-red': hasSolve === false,
            }"
            @click="handleSolve(false)"
          >
            <svg-icon
              v-if="hasSolve || hasSolve === null"
              icon-class="no-solve"
            />
            <svg-icon
              v-if="hasSolve === false"
              icon-class="no-solve"
            />
            未解决
          </el-button>
        </div>
        <p v-if="hasSolve" class="article-thanks">感谢您的投票!</p>
        <div v-if="hasSolve === false" class="article-noSolve">
          <span>很抱歉没解决您的问题。您可拨打</span><span
            style="color: #ec212d"
          >售后热线0570-3088009获取帮助，或在下方留言。</span>
          <!-- <el-form ref="form" :model="messageForm" label-width="80px" label-position="left">
          <el-form-item label="文档留言:">
            <el-input v-model="messageForm.message" maxlength="500" type="textarea" placeholder="请输入500字以内" />
          </el-form-item>
        </el-form> -->
          <div class="article-message">
            <span> 文档留言: </span>
            <el-input
              v-model="textarea"
              resize="none"
              type="textarea"
              size="medium"
              maxlength="500"
              placeholder="请输入500字以内"
            />
            <el-button
              class="el-button subbmitMsg"
              type="danger"
              plain
              @click="checkmessage"
            >提交留言</el-button>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import {
  getSecondTitList,
  getThirdTitList,
  getDocContent,
  getContentComment,
  contentComment
} from '@/api/help'
export default {
  data() {
    return {
      textarea: '', // 未解决原因
      pjshow: false, // 是否已投票
      hasSolve: null, // 是否解决了问题
      fid: '', // 所选文章fid
      titleTwo: [], // 二级标题
      titleThree: [], // 三级标题
      butshow: true, // 是否展示投票
      html: '', // 文章内容
      strType: '',
      strId: '',
      dataindex: [''],
      dataid: ''
    }
  },
  created() {
    // 二级标题渲染
    getSecondTitList({ FDocType: 1 }).then((res) => {
      this.titleTwo = res
      this.titleTwo.map((item) => {
        item.titleThree = []
      })
    })
  },
  mounted() {
    this.dataindex = []
    var querData = this.$route.query.data
    if (this.$route.query.id) {
      this.strType = this.$route.query.fTitle.substring(
        0,
        this.$route.query.length
      )
      this.strId = this.$route.query.id
      this.dataindex.push(this.strType)
      this.dataid = this.$route.query.id
      setTimeout(() => {
        this.handleOpen(this.strType, [this.strType])
        this.handleSelect(this.strId, [this.strType, this.strId])
      }, 500)
    } else {
      this.strType = this.$route.query.data.substring(
        0,
        this.$route.query.data.length
      )
      this.dataindex.push(querData)
      setTimeout(() => {
        this.handleOpen(this.strType, [this.strType])
      }, 500)
    }
  },
  methods: {
    titleChnage(id) {
      this.fid = id
    },
    // 点击提交留言
    checkmessage() {
      contentComment({
        fcomment: this.textarea,
        ffinished: 0,
        fplatformDocId: Number(this.fid) || Number(this.$route.query.id)
      }).then((res) => {
        if (res.result) {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.butshow = false
          this.pjshow = false
        } else {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    /**
     * 点击是否解决按钮
     */
    handleSolve(type) {
      if (this.butshow) {
        if (type) {
          contentComment({
            fcomment: '',
            ffinished: 1,
            fplatformDocId: Number(this.fid) || Number(this.$route.query.id)
          }).then((res) => {
            if (res.result) {
              this.$message({
                message: res.msg,
                type: 'success'
              })
              this.butshow = false
              this.hasSolve = type
              this.pjshow = false
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        } else {
          this.butshow = false
          this.hasSolve = type
        }
      }
    },
    // 点击三级标题
    handleSelect(a, b) {
      this.pjshow = false
      this.butshow = true
      getDocContent({ docID: Number(a) }).then((res) => {
        this.html = res.content
        getContentComment({ docID: Number(a) }).then((res1) => {
          if (res1.fid === 0) {
            this.hasSolve = null
            this.pjshow = true
          }
        })
      })
    },
    // 点击二级标题
    async handleOpen(a, b) {
      await getThirdTitList({ FDocType: 1, FDocTitle: a }).then((res) => {
        this.titleTwo.map((item) => {
          if (item.fdocTitle === b[0]) {
            item.titleThree = res
            item.hasSolve = null
            this.$forceUpdate()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.help-center {
  display: flex;
  height: 100%;
  .help-center-aside {
    width: 170px;
    .primary-title {
      background-color: red;
    }
  }
  .help-center-aside-nav {
    width: 169px;
    height: 36px;
    color: #fff;
    background-color: #ec212d;
    text-align: center;
    line-height: 36px;
    font-size: 18px;
  }
  .help-center-article {
    margin-left: 10px;
    background-color: #fff;
    padding: 20px;
    flex: 1;
    overflow-y: auto;
    // .article-html{
    //   height: 500px;
    //   max-height: 500px;
    //   overflow-y: auto;
    // }
    .article-title {
      color: #2475ea;
      font-size: 16px;
      text-align: center;
      margin-top: 20px;
    }
    .article-button-box {
        margin-top: 5px;
      text-align: center;
    }
    .article-button {
      width: 88px;
      height: 36px;
      line-height: 36px;
      font-size: 16px;
      border: 1px solid #999999;
      border-radius: 4px;
      padding: 0;
    }
    .active-green {
      background: #128f18;
      color: #fff;
    }
    .active-red {
      background: #ec212d;
      color: #fff;
    }
    .article-thanks {
      font-size: 12px;
      color: #128f18;
      text-align: center;
      margin-top: 11px;
    }
    .article-noSolve {
      margin-top: 11px;
      text-align: center;
      font-size: 18px;
      .article-message {
        display: flex;
        flex-direction: row;
        justify-content: center;
        position: relative;
        span {
          width: 80px;
          margin-top: 8px;
          text-align: left;
          color: #333;
        }
        .el-textarea {
          height: 253px;
        }

        .el-button {
          position: absolute;
          top: 210px;
          left: calc(50% + 200px);
          width: 101px;
          height: 36px;
          font-size: 12px;
          font-family: SimSun;
          font-weight: 400;
          text-align: center;
          line-height: 0;
        //   padding-left: 6px;
        }
        .subbmitMsg {
            background-color: #EC212D ;
            color: #fff;
        }
      }
      .el-textarea,
      .el-textarea__inner {
        margin-top: 8px;
        width: 565px !important;
        border: 1px solid #d2d2d2;
      }
    }
  }
}
</style>
<style lang="scss">
.article-message {
  .el-textarea__inner {
    height: 251px !important;
  }
}
.help-center {
  .el-menu-item-group__title {
    padding: 0;
  }
  .el-submenu__title {
    height: 36px;
    line-height: 36px;
    text-align: center;
    border: 1px solid #d2d2d2;
  }
  .el-submenu .el-menu-item {
    width: 169px;
    height: 36px;
    min-width: 169px;
    line-height: 36px;
    font-size: 12px;
    text-align: center;
    background-color: #fff !important;
  }
  .el-submenu.is-active .el-submenu__title {
    border-bottom: 1px solid #d2d2d2;
  }
  .el-button:hover {
    background-color: #fff;
    color: #606266;
  }
}
.help-center .el-menu-item is-active {
  color: #ed1925 !important;
}
</style>
